export type AnalyticsEvent =
  | 'world_load'
  | 'player_selected'
  | 'journey_started'
  | 'journey_completed'
  | 'landmark_discovered'
  | 'place_saved'
  | 'plan_shared'
  | 'partner_clicked'
  | 'roles_skipped'
  | 'roles_chosen'
  | 'world_reacted'
  | 'encounter_found'
  | 'route_chosen'
  | 'prediction_made'
  | 'photo_taken'
  | 'photo_viewed'
  | 'photo_deleted'
  | 'atlas_opened'
  | 'atlas_entry_read'
  | 'attraction_focused'
  | 'poi_opened'
  | 'compendium_filled'
  | 'quest_completed'
  | 'flight_entered'
  | 'companion_opened'
  | 'companion_located'
  | 'arrived_on_site'
  | 'sello_captured'
  | 'sello_deleted'
  | 'zone_entered'
  | 'zone_exited'

interface AnalyticsPayload {
  [key: string]: string | number | boolean | undefined
}

const STORAGE_KEY = 'roam:arenal:analytics'
const MAX_EVENTS = 200

export function track(event: AnalyticsEvent, payload: AnalyticsPayload = {}): void {
  const entry = {
    event,
    t: new Date().toISOString(),
    ...payload,
  }
  try {
    const prior = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]') as unknown[]
    const next = [...(Array.isArray(prior) ? prior : []), entry].slice(-MAX_EVENTS)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
  } catch {
    // Ignore storage failures.
  }
  if (import.meta.env.DEV) {
    console.info('[analytics]', entry)
  }
  window.dispatchEvent(new CustomEvent('roam:analytics', { detail: entry }))
}
